import React, { useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Context } from "../../../index";
import ButtonComponent from "../../buttons/ButtonComponent";
import { FilterBy } from "../../../shared/filter/FilterBy"; // <-- импорт
import "./styles.css";
import { observer } from "mobx-react-lite";

interface PageHeaderProps {
  title: string;
  onSearch?: () => void;
  onCreate?: () => void;
  searchTerm?: string;
  setSearchTerm?: (term: string) => void;
  buttontext?: string;
}

const PageHeader: React.FC<PageHeaderProps> = observer(
  ({ title, onSearch, onCreate, searchTerm, setSearchTerm, buttontext }) => {
    const { store } = useContext(Context);
    const location = useLocation();

    // Все хуки — строго в начале
    const [isSearchVisible, setIsSearchVisible] = useState(false);

    // Проверка после хуков — допустима
    if (
      store.user.role === "оператор организации" &&
      location.pathname !== "/inplants"
    ) {
      return null;
    }

    const startSearch = () => {
      isSearchVisible ? toDefault() : setIsSearchVisible(true);
    };

    const toDefault = () => {
      setIsSearchVisible(false);
      setSearchTerm?.("");
    };

    return (
      <div className="pageHeader">
        <div className="pageHeader_title">{title}</div>
        <div className="pageHeader_controls">
          {/* Фильтр по организации */}
          {location.pathname === "/plants" && store.user?.role === "root" && (
            <FilterBy
              label="Организация"
              options={store.companies.map((c) => ({ id: c.id, name: c.name }))}
              value={store.company?.id || null}
              onChange={(companyId) => {
                if (companyId === null) {
                  store.setCompany(null);
                } else {
                  const company = store.companies.find(
                    (c) => c.id === companyId,
                  );
                  store.setCompany(company || null);
                }
              }}
              placeholder="Выберите организацию"
            />
          )}

          {onSearch && !store.company?.id ? (
            <ButtonComponent
              title="поиск"
              svg="/Icon_serch.svg"
              onClick={startSearch}
              type="out"
            />
          ) : null}
          {isSearchVisible ? (
            <input
              className="pageHeader_searchInputField"
              type="text"
              placeholder="Поиск..."
              value={searchTerm || ""}
              onChange={(e) => setSearchTerm?.(e.target.value)}
              autoFocus
            />
          ) : null}
          {store.user.role === "root" && buttontext ? (
            <ButtonComponent
              title={buttontext}
              svg="create"
              onClick={onCreate}
            />
          ) : null}
        </div>
      </div>
    );
  },
);

export default PageHeader;
